import {Injectable, Injector, TemplateRef, Type} from '@angular/core';
import {Overlay, OverlayConfig} from '@angular/cdk/overlay';
import {ComponentPortal, ComponentType} from '@angular/cdk/portal';
import {DialogComponent} from './dialog.component';
import {DialogRef} from './dialog-ref';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private readonly _overlay: Overlay, private readonly _injector: Injector) {}

  open<R = any, T = any>(
    content: string | TemplateRef<any> | Type<any>,
    data: T,
  ): DialogRef<R> {
    return this._setUpDialog({content, data, component: DialogComponent});
  }

  openCustomComponent<R = any, T = any, C = any>(
    component: ComponentType<C>,
    data: T,
  ): DialogRef<R> {
    return this._setUpDialog({data, component});
  }

  private _setUpDialog<R = any, T = any, C = any>({
    content,
    data,
    component,
  }: {
    content?: string | TemplateRef<any> | Type<any>;
    data: T;
    component: ComponentType<C>;
  }) {
    const configs = new OverlayConfig({
      hasBackdrop: true,
      panelClass: ['dialog', 'is-active'],
      backdropClass: 'dialog-background',
    });

    const overlayRef = this._overlay.create(configs);

    const dialogRef = new DialogRef<R, T>(overlayRef, content || component, data);

    const injector = Injector.create({
      parent: this._injector,
      providers: [{provide: DialogRef, useValue: dialogRef}],
    });

    overlayRef.attach(new ComponentPortal(component, null, injector));

    return dialogRef;
  }
}
